import { useEffect } from "react";
import "../../styles/Contents.css";

export default function PreviousPapers() {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page">

      {/* HERO */}
      <section className="about-hero reveal">
        <h1>Previous Year Question Papers</h1>
        <p>
          Comprehensive collection of real exam papers for Classes 8, 9 & 10,
          covering both CBSE and State syllabus to boost confidence and results.
        </p>
      </section>

      {/* WHY PREVIOUS PAPERS */}
      <section className="about-section reveal-left">
        <div className="about-text">
          <h2>Why Previous Papers are Essential</h2>
          <p>
            Solving previous year papers is one of the most effective ways to
            prepare for exams. It helps students familiarize themselves with
            the format, understand question trends, and identify important topics.
          </p>
          <p>
            By practicing with real papers, students improve time management,
            reduce exam stress, and gain clarity on which areas require more focus.
          </p>
        </div>
      </section>

      {/* FEATURES */}
      <section className="mission-section reveal-right">
        <h2>What Our Question Papers Offer</h2>

        <div className="mission-grid reveal">
          <div className="mission-card">
            <h3>📝 Authentic & Verified</h3>
            <p>
              Includes board-level and school exam papers curated by our
              experienced faculty for accuracy and relevance.
            </p>
          </div>

          <div className="mission-card">
            <h3>📊 Exam Pattern Insight</h3>
            <p>
              Understand the marking scheme, frequently asked questions, and
              topic weightage to focus preparation efficiently.
            </p>
          </div>

          <div className="mission-card">
            <h3>⏱️ Time Management</h3>
            <p>
              Regular practice ensures students can complete exams within
              the time limit, improving accuracy and confidence.
            </p>
          </div>

          <div className="mission-card">
            <h3>📚 Subject Coverage</h3>
            <p>
              All major subjects are included: Mathematics, Science, Social
              Science, Languages, and more for Classes 8–10.
            </p>
          </div>

          <div className="mission-card">
            <h3>💡 Effective Strategy Tips</h3>
            <p>
              Learn to attempt questions strategically, prioritize important
              topics, and revise systematically for better exam performance.
            </p>
          </div>

          <div className="mission-card">
            <h3>🌐 CBSE & State Boards</h3>
            <p>
              Covers both CBSE and State syllabus ensuring every student can
              benefit, regardless of their board.
            </p>
          </div>
        </div>
      </section>

      {/* HOW TO USE */}
      <section className="mission-section reveal-left">
        <h2>How to Use These Papers Effectively</h2>
        <ul style={{ fontSize: "15px", color: "#475569", marginTop: "12px" }}>
          <li>✔ Attempt papers under exam-like conditions to build stamina.</li>
          <li>✔ Analyze mistakes and revise weak areas immediately.</li>
          <li>✔ Track time taken per section and aim to improve speed.</li>
          <li>✔ Combine with our Notes and DDPs for complete preparation.</li>
        </ul>
      </section>

      {/* FOOTER NOTE */}
      <section className="about-footer reveal">
        <p>
          Our previous year papers are regularly updated to reflect the latest
          exam patterns, making them a vital tool for students aiming for
          academic excellence.
        </p>
      </section>

    </div>
  );
}
